import { render, staticRenderFns } from "./InPageNavigationMobile.vue?vue&type=template&id=0bc877c2"
import script from "./InPageNavigationMobile.vue?vue&type=script&lang=js"
export * from "./InPageNavigationMobile.vue?vue&type=script&lang=js"
import style0 from "./InPageNavigationMobile.vue?vue&type=style&index=0&id=0bc877c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports